import {useEffect, useState} from "react";

import {IGenericBooster} from "../types/booster_generic/IGenericBooster";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IBoosterSegments} from "../types/IBoosterSegments";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {getBoosterFromStorage, saveBoosterToStorage} from "../utils/booster_storage";
import {getBoostersByPropertyType} from "../utils/get_boosters_by_property_type";
import {getRandomBooster} from "../utils/get_random_booster";
import {renderBoosterToString} from "../utils/render_booster_to_string";
import {IUsePropertyTypeProps, usePropertyType} from "./use_property_type";

interface IUseBoosterProps extends IUsePropertyTypeProps {
    offerId: string | number;
    propertyId?: string | number;
}

export interface IBoosterMetadata<TBoosterParams extends object> {
    stored?: boolean;
    category?: IBoosterCategory;
    type?: keyof IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>];
    boosterText?: string | null;
}

export const useBooster = <TBoosterParams extends object>(props: IUseBoosterProps & TBoosterParams) => {
    const [segments, setSegments] = useState<IBoosterSegments | null>(null);
    const [metadata, setMetadata] = useState<IBoosterMetadata<TBoosterParams> | null>(null);

    const propertyType = usePropertyType(props);

    useEffect(() => {
        if (!propertyType) {
            return;
        }

        const config = getBoostersByPropertyType(propertyType) as IGenericBoostersConfig<TBoosterParams>;
        if (!config) {
            return;
        }

        const storedBooster = getBoosterFromStorage<TBoosterParams>(props.offerId, props.propertyId);

        // If booster exists in storage, try to use it
        if (storedBooster && config[storedBooster.category] && config[storedBooster.category][storedBooster.type]) {
            const {category, type} = storedBooster;
            const boosterConfig = config[category][type] as IGenericBooster<TBoosterParams>;

            if (boosterConfig.isValid(props)) {
                const boosterSegments = boosterConfig.getSegments(props);
                if (boosterSegments) {
                    setSegments(boosterSegments);
                    setMetadata({stored: true, category, type, boosterText: renderBoosterToString(boosterConfig, props)});
                    return;
                }
            }
        }

        // If booster doesn't exist in storage or is invalid, try to draw a new one
        const randomBooster = getRandomBooster(config, props);
        if (randomBooster) {
            const category = randomBooster.category;
            const type = randomBooster.type as keyof IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>];
            const boosterConfig = config[category][type] as IGenericBooster<TBoosterParams>;
            const boosterSegments = boosterConfig.getSegments(props);

            if (boosterSegments) {
                setSegments(boosterSegments);
                setMetadata({stored: false, category, type, boosterText: renderBoosterToString(boosterConfig, props)});
                saveBoosterToStorage(category, type, props.offerId, props.propertyId);
            }
        }
    }, [propertyType, props.offerId, props.propertyId]);

    return {segments, metadata};
};
import {useEffect, useState} from "react";

import {IGenericBooster} from "../types/booster_generic/IGenericBooster";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IBoosterSegments} from "../types/IBoosterSegments";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {getBoosterFromStorage, saveBoosterToStorage} from "../utils/booster_storage";
import {getBoostersByPropertyType} from "../utils/get_boosters_by_property_type";
import {getRandomBooster} from "../utils/get_random_booster";
import {renderBoosterToString} from "../utils/render_booster_to_string";
import {IUsePropertyTypeProps, usePropertyType} from "./use_property_type";

interface IUseBoosterProps extends IUsePropertyTypeProps {
    offerId: string | number;
    propertyId?: string | number;
}

export interface IBoosterMetadata<TBoosterParams extends object> {
    stored?: boolean;
    category?: IBoosterCategory;
    type?: keyof IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>];
    boosterText?: string | null;
}

export const useBooster = <TBoosterParams extends object>(props: IUseBoosterProps & TBoosterParams) => {
    const [segments, setSegments] = useState<IBoosterSegments | null>(null);
    const [metadata, setMetadata] = useState<IBoosterMetadata<TBoosterParams> | null>(null);

    const propertyType = usePropertyType(props);

    useEffect(() => {
        if (!propertyType) {
            return;
        }

        const config = getBoostersByPropertyType(propertyType) as IGenericBoostersConfig<TBoosterParams>;
        if (!config) {
            return;
        }

        const storedBooster = getBoosterFromStorage<TBoosterParams>(props.offerId, props.propertyId);

        // If booster exists in storage, try to use it
        if (storedBooster && config[storedBooster.category] && config[storedBooster.category][storedBooster.type]) {
            const {category, type} = storedBooster;
            const boosterConfig = config[category][type] as IGenericBooster<TBoosterParams>;

            if (boosterConfig.isValid(props)) {
                const boosterSegments = boosterConfig.getSegments(props);
                if (boosterSegments) {
                    setSegments(boosterSegments);
                    setMetadata({stored: true, category, type, boosterText: renderBoosterToString(boosterConfig, props)});
                    return;
                }
            }
        }

        // If booster doesn't exist in storage or is invalid, try to draw a new one
        const randomBooster = getRandomBooster(config, props);
        if (randomBooster) {
            const category = randomBooster.category;
            const type = randomBooster.type as keyof IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>];
            const boosterConfig = config[category][type] as IGenericBooster<TBoosterParams>;
            const boosterSegments = boosterConfig.getSegments(props);

            if (boosterSegments) {
                setSegments(boosterSegments);
                setMetadata({stored: false, category, type, boosterText: renderBoosterToString(boosterConfig, props)});
                saveBoosterToStorage(category, type, props.offerId, props.propertyId);
            }
        }
    }, [propertyType, props.offerId, props.propertyId]);

    return {segments, metadata};
};
